import leadershipTeam from "../../assets/leadership-team.jpg";
import { ArrowDown } from "lucide-react";

const UseCase = () => {
  return (
    <section id="use-case" className="py-12 lg:py-14">
      <div className="container-tight">
        <div className="max-w-3xl">
          <span className="eyebrow">A real conversation</span>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            How a CFO actually used Signal AI.
          </h2>
        </div>

        <div className="mt-14 grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-2xl border border-border shadow-card">
              <img
                src={leadershipTeam}
                alt="Leadership team reviewing AI ROI insights"
                width={1280}
                height={800}
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="mt-6 rounded-xl border border-border bg-card p-5 shadow-soft">
              <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">Outcome</p>
              <p className="mt-2 text-lg font-semibold text-foreground">38% reduction in cycle time</p>
              <p className="text-sm text-muted-foreground">Within the first 90 days without overhauling existing systems.</p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative space-y-6 border-l border-border pl-8">
              {[
                { who: "CFO", text: "We've talked about AI for two quarters. Nobody can tell me what it'll actually save us." },
                { who: "Signal AI", text: "Let's start with where money currently leaks. Walk me through your top 3 finance workflows.", accent: true },
                { who: "CFO", text: "Vendor reconciliation, monthly close, and contract review." },
                { who: "Signal AI", text: "Vendor reconciliation alone has a $1.8M – $2.4M annual ROI band. Readiness is high. Start here.", accent: true },
                { who: "CFO", text: "And the others?" },
                { who: "Signal AI", text: "Defer. Lower ROI confidence, higher data prep cost. Revisit in 90 days.", accent: true },
              ].map((m, i) => (
                <div key={i} className="relative">
                  <span className={`absolute -left-[33px] top-2 h-2.5 w-2.5 rounded-full ring-4 ring-background ${m.accent ? "bg-signal" : "bg-foreground"}`} />
                  <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{m.who}</p>
                  <p className={`mt-1 text-base leading-relaxed ${m.accent ? "text-foreground font-medium" : "text-muted-foreground"}`}>{m.text}</p>
                </div>
              ))}
            </div>

            <div className="mt-10 space-y-3 rounded-2xl border border-border bg-secondary/50 p-6">
              <div className="flex items-start gap-3">
                <ArrowDown className="mt-1 h-4 w-4 text-signal" />
                <p className="text-base text-foreground">
                  What made this possible wasn't a large transformation upfront it was starting with the right problem, in a low-risk, structured way.
                </p>
              </div>
              <p className="pl-7 text-sm text-muted-foreground">
                That's exactly how most teams begin with Signal AI at <span className="font-semibold text-signal">$0</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCase;
